import { useRef, useState } from "react";
import { toast } from "sonner";
import { Save, Upload, Trash2, KeyRound } from "lucide-react";
import { api, errorText } from "@/lib/api";
import { PanelHead } from "../shared";
import { useLogo } from "./useLogo";

const FIELDS = [["name", "Firma adı", true], ["app_name", "Uygulama adı (menü ve raporlar)", true], ["phone", "Telefon"], ["email", "E-posta"], ["tax_office", "Vergi dairesi"], ["tax_no", "Vergi no"], ["address", "Adres"]];

const LogoBox = ({ company, onSaved }) => {
  const src = useLogo(company);
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const run = async (fn, msg) => { setBusy(true); try { onSaved((await fn()).data); toast.success(msg); } catch (e) { toast.error(errorText(e, "Logo yüklenemedi")); } setBusy(false); };
  const upload = (file) => { if (!file) return; const fd = new FormData(); fd.append("file", file); run(() => api.post("/settings/logo", fd), "Logo güncellendi"); };
  return <div className="logo-box" data-testid="company-logo-box">
    <img src={src} alt="Firma logosu" data-testid="company-logo-preview" />
    <input ref={input} type="file" accept="image/png,image/jpeg" hidden onChange={e => { upload(e.target.files[0]); e.target.value = ""; }} data-testid="company-logo-input" />
    <button className="outline-btn compact" disabled={busy} onClick={() => input.current.click()} data-testid="company-logo-upload-button"><Upload size={14} /> {busy ? "Yükleniyor..." : "Logo yükle"}</button>
    {company.logo_path && <button className="outline-btn compact" disabled={busy} onClick={() => run(() => api.delete("/settings/logo"), "Varsayılan logoya dönüldü")} data-testid="company-logo-remove-button"><Trash2 size={14} /> Kaldır</button>}
    <small>PNG veya JPG, en fazla 2 MB</small>
  </div>;
};

export default function CompanyForm({ settings, onSaved, changePw }) {
  const company = settings.company;
  const submit = async (e) => {
    e.preventDefault();
    try { onSaved((await api.put("/settings/company", Object.fromEntries(new FormData(e.currentTarget)))).data); toast.success("Firma bilgileri kaydedildi"); }
    catch (err) { toast.error(errorText(err)); }
  };
  return <div className="settings-company">
    <section className="panel" data-testid="company-section"><PanelHead title="Firma bilgileri" sub="Menüde, tarayıcı başlığında ve PDF/Excel raporlarında kullanılır." />
      <LogoBox company={company} onSaved={onSaved} />
      <form className="settings-form" onSubmit={submit} data-testid="company-form">
        {FIELDS.map(([n, l, req]) => <label key={n} className={n === "address" ? "wide" : ""}>{l}<input name={n} defaultValue={company[n]} required={req} data-testid={`company-${n}-input`} /></label>)}
        <button className="primary-btn" data-testid="company-save-button"><Save size={15} /> Kaydet</button>
      </form></section>
    <section className="panel" data-testid="security-section"><PanelHead title="Güvenlik" sub="Hesap şifrenizi buradan değiştirebilirsiniz." />
      <button className="outline-btn" onClick={changePw} data-testid="settings-change-password-button"><KeyRound size={15} /> Şifre değiştir</button></section>
  </div>;
}
